import { AddPhotoAlternate } from "@mui/icons-material";
import { Box, Button, Paper, Typography } from "@mui/material";

export default function SectionHeader({ title, heading, subHeading, onAdd }) {
  return (
    <Paper
      elevation={2}
      sx={{ p: 3, mb: 4, borderRadius: 3, bgcolor: "background.paper" }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        <Box>
          <Typography variant="h6" fontWeight={500} gutterBottom>
            {heading}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {subHeading}
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddPhotoAlternate />}
          onClick={onAdd}
          size="large"
          sx={{ borderRadius: 2 }}
        >
          Add New {title}
        </Button>
      </Box>
    </Paper>
  );
}
